import React from 'react'
import { connect } from 'react-redux'
import {
  Field,
  Form,
  reduxForm,
  // formValueSelector,
  change,
  getFormValues,
  formValueSelector,
  reset
} from 'redux-form'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory } from 'react-router-dom'

import ReactSelect from '../select/ReactSelect'
import Button from '../button/Button'
import StyledSVG from '../shared/StyledSVG'
import UserAvatar from '../shared/UserAvatar'
import AsyncSelect from '../shared/AsyncSelect'
import CreateChatGroupForm from './CreateChatGroupForm'
import CheckboxInput from '../input/CheckboxInput'
import { roles, colors } from '../../utils/constants'
import { numberFromText } from '../../utils/helpers'
import { occupationsObject } from '../../utils/dicts'
import { createChatRSPA } from '../../store/chats/actions'
import { getFilteredContacts } from '../../store/users/actions'
import searchIcon from '../../assets/icons/search-icon.svg'
import removeButton from '../../assets/icons/red-circle-remove.svg'
import CircularProgress from '@material-ui/core/CircularProgress'

import { Avatar, makeStyles } from '@material-ui/core'
import { AvatarGroup } from '@material-ui/lab'
import Tooltip from '@material-ui/core/Tooltip'
import Input from '@material-ui/core/Input'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    overflow: 'hidden'
  },
  group_form_root: {
    height: '85%',
    width: '100%'
  },
  header: {
    backgroundColor: '#ADB8CC33',
    color: '#386093',
    padding: '15px 40px',
    '& h1': {
      margin: 0,
      fontWeight: '700',
      fontSize: 16
    }
  },
  destinations_section: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '20px 40px',
    position: 'relative',
    '& .label': {
      margin: 0
    },
    [theme.breakpoints.down('1000')]: {
      padding: '10px 20px'
    }
  },
  add_member: {
    margin: 0,
    borderRadius: 4,
    padding: 4,
    backgroundColor: '#EFF0F2',
    cursor: 'pointer',
    [theme.breakpoints.down('1000')]: {
      fontSize: '12px'
    },
    [theme.breakpoints.down('856')]: {
      fontSize: '10px'
    },
    [theme.breakpoints.down('600')]: {
      fontSize: '12px'
    }
  },
  destination_form: {
    cursor: 'default',
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    position: 'absolute',
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    top: '-50px',
    left: '11px',
    height: '83vh',
    width: '93%',
    border: '1px solid #CED6E0',
    boxShadow: `
      0px 13px 29px 0px #0000001A,
      0px 52px 52px 0px #00000017,
      0px 117px 70px 0px #0000000D,
      0px 208px 83px 0px #00000003,
      0px 326px 91px 0px #00000000
    `,
    overflowY: 'scroll',
    overflowX: 'hidden'
  },
  destination_form_options: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    margin: '4px 0px',
    width: '100%',
    [theme.breakpoints.down('1400')]: {
      justifyContent: 'left'
    },
    [theme.breakpoints.down('1000')]: {
      flexDirection: 'column'
    }
  },
  filter_buttons: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    width: '100%',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('1400')]: {
      justifyContent: 'right'
    },
    [theme.breakpoints.down('1000')]: {
      justifyContent: 'center'
    }
  },
  filter_section: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0px 20px',
    [theme.breakpoints.down('1400')]: {
      flexDirection: 'column',
      justifyContent: 'left'
    }
  },
  horizontal_bar: {
    width: '100%',
    height: 1,
    borderBottom: '2px solid #EFF0F2'
  },
  form_wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginBottom: 0,
    '& h1.label': {
      fontSize: 14,
      fontWeight: '600',
      margin: 0,
      padding: '15px 20px 0px 20px'
    }
  },
  async_select_class: {
    width: 160,
    '& .select__placeholder': {
      color: '#386093 !important',
      fontSize: '14px !important'
    },
    [theme.breakpoints.down('1400')]: {
      width: 180
    },
    [theme.breakpoints.down('1000')]: {
      width: 250
    },
    [theme.breakpoints.down('756')]: {
      width: 210
    }
  },
  contacts_list: {
    width: '100%'
  },
  contact: {
    margin: '8px 0px',
    padding: '8px 0px 8px 15px',
    display: 'flex',
    gap: 8,
    transition: 'background-color 0.3s ease-in-out',
    '&:hover': {
      backgroundColor: '#ADB8CC33'
    },
    '& h1.user_name': {
      fontWeight: 500,
      fontSize: 16,
      color: '#555555',
      transition: 'color 0.3s ease-in-out'
    },
    '& p.user_occupation': {
      fontWeight: 400,
      fontSize: 12,
      color: '#9B9B9B',
      transition: 'color 0.3s ease-in-out'
    }
  },
  contact_seleted: {
    '& h1.user_name': {
      fontWeight: 700,
      color: '#386093'
    },
    '& p.user_occupation': {
      color: '#386093'
    },
    backgroundColor: '#E9FAD9',
    '&:hover': {
      backgroundColor: '#E9FAD9'
    }
  },
  contact_name: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& h1': {
      margin: 0
    },
    '& p': {
      margin: 0
    }
  },
  room_member: {
    backgroundColor: '#EFF0F2',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    height: 30,
    padding: 8,
    gap: 8,
    '& .remove_member': {
      cursor: 'pointer'
    }
  },
  members_section: {
    marginTop: 16,
    '& .list': {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 4
    }
  },
  bottom_section: {
    padding: '5px 24px 20px 24px',
    width: '100%',
    '& .label': {
      marginBottom: 10,
      marginTop: 10,
      fontWeight: 600,
      fontSize: 16,
      margin: 0
    }
  },
  bottom_buttons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 16,
    marginRight: 20,
    marginTop: 20
  },
  select_btn: {
    backgroundColor: '#386093',
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#386093'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  remove_filter_btn: {
    height: 44,
    width: 'fit-content',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '& path': {
      stroke: '#386093'
    },
    '& h1': {
      fontWeight: 700,
      fontSize: 14,
      textAlign: 'center',
      color: '#386093',
      textDecorationColor: '#386093',
      textDecoration: 'underline'
    }
  },
  arrow_to_right: {
    '& path': {
      stroke: '#FFFFFF'
    }
  },
  apply_btn: {
    backgroundColor: '#386093',
    width: 120,
    height: 40,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#386093'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px',
    '& .MuiButton-label': {
      fontSize: 14
    },
    [theme.breakpoints.down('756')]: {
      width: 100
    }
  },
  search_component: {
    maxWidth: '450px',
    height: 40,
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1px solid #D2D5D8',
    '& input': {
      padding: 0
    }
  },
  search_by_name_section: {
    margin: '15px 0px 19px 0px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '0px 20px',
    '& .label': {
      fontSize: 16,
      fontWeight: 600
    }
  },
  edit_members: {
    fontWeight: 600,
    fontSize: 14,
    textDecoration: 'underline',
    color: '#386093',
    textDecorationColor: '#386093',
    cursor: 'pointer',
    margin: 0
  },
  header_wrapper: {
    height: '15%'
  },
  clearBtn: {
    backgroundColor: '#EF7C8F',
    width: 120,
    height: 40,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#EF7C8F'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px',
    [theme.breakpoints.down('756')]: {
      width: 100
    }
  },
  react_select: {
    width: 160,
    height: 50,
    '& .select__control': {
      height: 50
    }
  },
  end_message: {
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 30
  }
}))

const CreateChatForm = ({
  isDirectMsg,
  isGroupMsg,
  handleSubmit,
  onSubmit,
  // submitting,
  touch,
  change,
  fieldValues,
  handleUnselectForms,
  userOccupations,
  createChatRSPA,
  currentUserId,
  schoolId,
  classroomValue,
  gradeValue,
  occupationValue,
  getFilteredContacts
}) => {
  const classes = useStyles()
  const history = useHistory()
  const modalRef = React.useRef(null)
  const selectGradeRef = React.useRef(null)
  const selectClassroomRef = React.useRef(null)
  const selectOccupationRef = React.useRef(null)
  const [inputExpanded, setInputExpanded] = React.useState(false)
  const [currentContactPage, setCurrentContactPage] = React.useState(1)
  const [contactNameFilter, setContactNameFilter] = React.useState('')
  const [contacts, setContacts] = React.useState([])
  const [contactsMeta, setContactsMeta] = React.useState(null)
  const [errorSearchName, setErrorSearchName] = React.useState('')
  const [selectedUsers, setSelectedUsers] = React.useState([])
  const [dataToCreateGroup, setDataToCreateGroup] = React.useState(null)

  const [isLoading, setIsLoading] = React.useState(false)
  const isAdmin =
    userOccupations?.includes(roles.SCHOOL_ADMIN) ||
    userOccupations?.includes(roles.VERSAR_ADMIN)
  const defaultParams = {
    'q[id_not_in]': currentUserId
  }

  const occupationsObjectChat = [
    [1, 'Administrador'],
    [2, 'Administrador da escola'],
    [8, 'Professor(a)'],
    [9, 'Estudante'],
    [10, 'Responsável'],
    [6, 'Coordenador']
  ]

  React.useEffect(
    () => {
      function handleClickOutside (event) {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
          setInputExpanded(false)
        }
      }

      if (inputExpanded) {
        document.addEventListener('mousedown', handleClickOutside)
      }

      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    },
    [inputExpanded]
  )

  React.useEffect(
    () => {
      setInputExpanded(false)
      setSelectedUsers([])
    },
    [isDirectMsg, isGroupMsg]
  )

  React.useEffect(() => {
    const fetchContacts = async () => {
      setIsLoading(true)
      await getUsersFiltered(currentContactPage, res => {
        setContacts(res)
      })
      setIsLoading(false)
    }
    fetchContacts()
  }, [])

  const getUsersFiltered = async (page, processData, params) => {
    await getFilteredContacts({
      params: {
        ...defaultParams,
        occupation_id: occupationValue,
        grade_id: gradeValue,
        classroom_id: classroomValue,
        page: page,
        include: 'user_occupations.occupation',
        ...params
      }
    })
      .then(res => {
        setContactsMeta(res?.meta)
        processData(res.data)
        setIsLoading(false)
      })
      .catch(error => {
        console.error(error)
        setContactsMeta({ total_count: null, page_count: null })
        setErrorSearchName(error[0]?.detail)
        processData([])
        setIsLoading(false)
      })
  }

  const handleSearchByFilters = () => {
    setIsLoading(true)
    setCurrentContactPage(1)
    getUsersFiltered(
      1,
      res => {
        setContacts(res)
      },
      { 'q[name_cont]': contactNameFilter }
    )
  }

  const handleSeachByName = event => {
    setContactNameFilter(event.target.value)
  }

  const handleClearFields = () => {
    reset()
    selectGradeRef.current?.select.clearValue()
    selectClassroomRef.current?.select.clearValue()
    selectOccupationRef.current?.select.clearValue()
    setContactNameFilter('')
    setCurrentContactPage(1)
    setContactsMeta(null)
    setContacts([])
    setIsLoading(true)
    getUsersFiltered(
      1,
      res => {
        setContacts(res)
      },
      { occupation_id: null, grade_id: null, classroom_id: null }
    )
  }

  const handleChange = (event, input) => {
    const inputName = input.name
    touch(inputName)

    let newValue
    if (Array.isArray(event)) {
      newValue = event?.map(v => v)
    } else {
      newValue = event ? event.value : ''
    }
    if (inputName === 'grade_id' && !newValue) {
      selectClassroomRef.current?.select.clearValue()
    }
    change(input.name, newValue)
  }

  const fetchMoreContactsFiltered = async page => {
    getUsersFiltered(page, res => {
      setContacts(prev => {
        return prev.concat(res)
      })
      setCurrentContactPage(currentContactPage + 1)
    })
  }

  const handleSelectContact = async () => {
    const newChat = {
      app_id: +process.env.REACT_APP_PROJECT_ID,
      room_participants_attributes: [
        {
          user_id: currentUserId,
          is_moderator: !!isAdmin,
          occupation_name: userOccupations?.[0]
        },
        ...selectedUsers.map(item => {
          return {
            user_id: item.user_id,
            is_moderator: false,
            occupation_name: item.user_occupation
          }
        })
      ]
    }
    if (isDirectMsg) {
      const response = await createChatRSPA(
        Object.assign(newChat, {
          room_type: 1
        })
      ).then(res => res)
      handleUnselectForms()
      if (response.data.data.id) {
        history.push(`/rooms/${response.data.data.id}`)
      }
    } else {
      setDataToCreateGroup(newChat)
      setInputExpanded(!inputExpanded)
    }
  }

  const handleCheck = (event, user) => {
    if (isDirectMsg) {
      setSelectedUsers(prev => {
        return [
          {
            user_id: user.id,
            user_name: user.name,
            user_avatar: user.avatar_url,
            user_occupation: user.user_occupations?.[0].occupation.name
          }
        ]
      })
    } else {
      setSelectedUsers(prevSelected => {
        if (event.target.checked) {
          return [
            ...prevSelected,
            {
              user_id: user.id,
              user_name: user.name,
              user_avatar: user.avatar_url,
              user_occupation: user.user_occupations?.[0]?.occupation?.name
            }
          ]
        } else {
          return prevSelected.filter(u => u.user_id !== user.id)
        }
      })
    }
  }

  const handleMemberSectionContent = () => {
    let storageData = Object.assign(
      {},
      {
        ...(isDirectMsg
          ? {
              firstLabel: 'Nova mensagem',
              secondLabel: 'Para',
              memberInputComponent: (
                <p
                  onClick={() => setInputExpanded(!inputExpanded)}
                  className={classes.add_member}
                >
                  Clique aqui para selecionar um contato
                </p>
              )
            }
          : {
              firstLabel: 'Novo grupo',
              secondLabel: 'Membros',
              memberInputComponent: (
                <>
                  {selectedUsers.length > 0 && !inputExpanded ? (
                    <>
                      <AvatarGroup max={5} spacing={1}>
                        {selectedUsers.map((user, idx) => {
                          const index =
                            numberFromText(user.user_name?.slice(0, 2)) %
                            colors.length
                          return (
                            <Tooltip
                              key={`user[${idx}]`}
                              title={user.user_name}
                              arial-label='usuario'
                            >
                              <Avatar
                                style={{
                                  height: '30px',
                                  width: '30px',
                                  backgroundColor:
                                    // eslint-disable-next-line standard/computed-property-even-spacing
                                    colors[index]
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: '14px',
                                    fontWeight: 400,
                                    lineHeight: '17px',
                                    letterSpacing: '0em',
                                    textAlign: 'left'
                                  }}
                                >
                                  {user.user_name[0]}
                                </p>
                              </Avatar>
                            </Tooltip>
                          )
                        })}
                      </AvatarGroup>
                      <p
                        onClick={() => setInputExpanded(true)}
                        className={classes.edit_members}
                      >
                        Editar
                      </p>
                    </>
                  ) : (
                    <p
                      onClick={() => setInputExpanded(!inputExpanded)}
                      className={classes.add_member}
                    >
                      Clique aqui para adicionar membros
                    </p>
                  )}
                </>
              )
            })
      }
    )

    return (
      <div className={classes.header_wrapper}>
        <div className={classes.header}>
          <h1>{storageData.firstLabel}</h1>
        </div>
        <div className={classes.destinations_section}>
          <p className='label'>{storageData.secondLabel}</p>
          {storageData.memberInputComponent}
          {inputExpanded && (
            <div ref={modalRef} className={classes.destination_form}>
              <div className={classes.form_wrapper}>
                <h1 className='label'>Filtros:</h1>
                <div className={classes.filter_section}>
                  <div className={classes.destination_form_options}>
                    <Field
                      component={ReactSelect}
                      id='occupation_id'
                      name='occupation_id'
                      placeholder='Ocupação'
                      handleChange={handleChange}
                      componentClass={classes.react_select}
                      selectRef={selectOccupationRef}
                      defaultValue={occupationValue}
                      touch={touch}
                      options={occupationsObjectChat.map(item => {
                        return {
                          label: item[1],
                          value: item[0]
                        }
                      })}
                    />
                    <Field
                      component={AsyncSelect}
                      rootStyle={classes.async_select_class}
                      defaultOptions={false}
                      isClearable
                      id='grade_id'
                      name='grade_id'
                      disabled={!occupationValue}
                      placeholder='Série'
                      selectRef={selectGradeRef}
                      cacheUniqs={[occupationValue]}
                      handleAsyncChange={handleChange}
                      searchParam='q[name_cont]'
                      request={{
                        path: 'grade',
                        params: {
                          'q[classrooms_school_id_in]': schoolId
                        }
                      }}
                      touch={touch}
                    />
                    <Field
                      component={AsyncSelect}
                      rootStyle={classes.async_select_class}
                      defaultOptions={false}
                      isClearable
                      id='classroom_id'
                      name='classroom_id'
                      placeholder='Turma'
                      disabled={!occupationValue || !gradeValue}
                      selectRef={selectClassroomRef}
                      handleAsyncChange={handleChange}
                      cacheUniqs={[gradeValue, occupationValue]}
                      searchParam='q[name_cont]'
                      request={{
                        path: 'classroom',
                        params: {
                          'q[occupation_id_in]': occupationValue,
                          'q[grade_id_in]': gradeValue,
                          'q[school_id_in]': schoolId,
                          'q[year_lteq]': new Date().getFullYear() + 1,
                          'q[year_gteq]': new Date().getFullYear()
                        }
                      }}
                      touch={touch}
                    />
                  </div>
                  <div className={classes.filter_buttons}>
                    <Button
                      onClick={() => handleClearFields()}
                      className={classes.clearBtn}
                    >
                      Limpar
                    </Button>
                    <Button
                      onClick={() => handleSearchByFilters()}
                      disabled={!classroomValue}
                      className={classes.apply_btn}
                    >
                      Aplicar
                    </Button>
                  </div>
                </div>
              </div>
              <div className={classes.search_by_name_section}>
                <h1 className='label'>Selecione o contato</h1>
                <Input
                  disableUnderline
                  value={contactNameFilter}
                  className={classes.search_component}
                  placeholder='Busque pelo nome'
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      handleSearchByFilters()
                    }
                  }}
                  onChange={e => handleSeachByName(e)}
                  startAdornment={
                    <StyledSVG
                      style={{ marginRight: 4 }}
                      src={searchIcon}
                      width={18}
                      height={18}
                    />
                  }
                />
              </div>
              {isLoading ? (
                <div className={classes.contacts_list}>
                  <div className={classes.horizontal_bar} />
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '40vh',
                      textAlign: 'center'
                    }}
                  >
                    <CircularProgress size={30} disableShrink thickness={4} />
                  </div>
                  <div className={classes.horizontal_bar} />
                </div>
              ) : (
                <div className={classes.contacts_list}>
                  <div className={classes.horizontal_bar} />
                  <InfiniteScroll
                    dataLength={contacts.length}
                    next={() =>
                      fetchMoreContactsFiltered(currentContactPage + 1)
                    }
                    height='40vh'
                    hasMore={contactsMeta?.total_count > contacts.length}
                    loader={
                      <div className={classes.end_message}>
                        <CircularProgress
                          size={30}
                          disableShrink
                          thickness={4}
                        />
                      </div>
                    }
                    endMessage={
                      <p className={classes.end_message}>
                        {(contactsMeta?.total_count === contacts.length) &
                        (contacts.length > 0) ? (
                          <b>Todos os contatos carregados.</b>
                        ) : errorSearchName ? (
                          <b>{errorSearchName}</b>
                        ) : (
                          <b>Nenhum contato encontrado.</b>
                        )}
                      </p>
                    }
                  >
                    {contacts.map((item, index) => {
                      const isSelected = selectedUsers.some(
                        u => u.user_id === item.id
                      )
                      return (
                        <div
                          className={`${classes.contact} ${isSelected &&
                            classes.contact_seleted}`}
                          key={index}
                        >
                          <CheckboxInput
                            name={`user_${item.id}`}
                            checked={isSelected}
                            handleCheck={event => handleCheck(event, item)}
                          />

                          <UserAvatar
                            avatarUrl={item?.avata_url}
                            userName={item.name}
                            withoutUserName
                          />
                          <div className={classes.contact_name}>
                            <h1 className='user_name'>{item.name}</h1>
                            {(item.user_occupations || [])
                              .filter(
                                (itemOccupation, idx, self) =>
                                  self.findIndex(
                                    o =>
                                      o.occupation.name ===
                                      itemOccupation.occupation.name
                                  ) === idx
                              )
                              .map((itemOccupation, i) => (
                                <p key={i} className='user_occupation'>
                                  {
                                    occupationsObject[
                                      itemOccupation.occupation.name
                                    ]
                                  }
                                </p>
                              ))}
                          </div>
                        </div>
                      )
                    })}
                  </InfiniteScroll>
                  <div className={classes.horizontal_bar} />
                </div>
              )}
              <div className={classes.bottom_section}>
                <h1 className='label'>Membros:</h1>
                {selectedUsers.length > 0 && (
                  <div className={classes.members_section}>
                    <div className='list'>
                      {selectedUsers.map((item, index) => {
                        return (
                          <div key={index} className={classes.room_member}>
                            <UserAvatar
                              avatarStyle={{ width: 24, height: 24 }}
                              avatarUrl={item?.user_avatar}
                              userName={item.user_name}
                            />
                            <StyledSVG
                              className='remove_member'
                              onClick={() =>
                                setSelectedUsers(prev => {
                                  return prev.filter(
                                    i => +i.user_id !== +item.user_id
                                  )
                                })
                              }
                              src={removeButton}
                              width={14}
                              height={14}
                            />
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )}
                <div className={classes.bottom_buttons}>
                  <Button
                    onclick={() => handleSelectContact()}
                    className={classes.select_btn}
                    disabled={selectedUsers?.length < 1}
                  >
                    Selecionar
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <Form className={classes.root} onSubmit={handleSubmit(onSubmit)}>
      <div className={classes.root}>
        <div style={{ height: 'auto' }}>{handleMemberSectionContent()}</div>
        <div className={classes.horizontal_bar} />
        {!isDirectMsg && (
          <div className={classes.group_form_root}>
            <CreateChatGroupForm
              history={history}
              handleUnselectForms={handleUnselectForms}
              createChatRSPA={createChatRSPA}
              dataToCreateGroup={dataToCreateGroup}
              selectedUsers={selectedUsers}
              setDataToCreateGroup={setDataToCreateGroup}
              currentUserId={currentUserId}
              change={change}
              fieldValues={fieldValues}
            />
          </div>
        )}
      </div>
    </Form>
  )
}

const mapStateToProps = (state, props) => {
  const selector = formValueSelector('createChatForm')
  return {
    userOccupations: state.auth.currentOccupation,
    fieldValues: getFormValues('createChatForm')(state),
    currentUserId: state?.auth?.user?.data?.id,
    schoolId: state.school?.currentSchool?.school_id,
    classroomValue: selector(state, 'classroom_id'),
    gradeValue: selector(state, 'grade_id'),
    occupationValue: selector(state, 'occupation_id')
  }
}

const mapDispatchToProps = dispatch => ({
  createChatRSPA: data => dispatch(createChatRSPA.request(data)),
  change: (field, data) => dispatch(change('createChatForm', field, data)),
  getFilteredContacts: data => dispatch(getFilteredContacts.request(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'createChatForm',
    // enableReinitialize: true,
    // touchOnChange: true,
    // touchOnBlur: true,
    onSubmit: async (values, dispatch, props) => {}
  })(CreateChatForm)
)
